"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TAB_KEY = exports.TAB_KEY = 9;
var ENTER_KEY = exports.ENTER_KEY = 13;
var ESCAPE_KEY = exports.ESCAPE_KEY = 27;
var LEFT_KEY = exports.LEFT_KEY = 37;
var UP_KEY = exports.UP_KEY = 38;
var RIGHT_KEY = exports.RIGHT_KEY = 39;
var DOWN_KEY = exports.DOWN_KEY = 40;
var DELETE_KEY = exports.DELETE_KEY = 46;
var BACKSPACE_KEY = exports.BACKSPACE_KEY = 8;


//////////////////
// WEBPACK FOOTER
// ./~/react-datasheet/lib/keys.js
// module id = 329
// module chunks = 0